import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type * as dms from '../../../../dms'
import * as organizations from '../../../organizations'
import type { Collection } from '../collection'

/**
 * Loads the organizations whenever the accounts are loaded, since this
 * collection serves only the payrolls themselves while the organization
 * columns present those by code and name.
 */
export const loadOrganizationsOnListLoad = store.effects.create(
  (
    _feature: Collection['feature'],
    collection: Collection,
    organizationsFeature: organizations.Feature,
    schemaFeature: dms.schema.Feature,
  ) =>
    collection.plugins.currentListPlugin.feature.actions.load.request
      .observe()
      .pipe(
        rxjsUtils.latestFrom(
          action => ({
            action: rxjs.of(action),
            schema: schemaFeature.selectors.schema.asObservable,
          }),
          ({ schema }) => schema.areModelsInitialized,
        ),
        rxjs.switchMap(({ action, schema }) =>
          rxjs
            .from(
              schema
                .getEntitiesInDimension(organizations.constants.DIMENSION_ID)
                .map((entity: ents.core.dms.models.Entity) =>
                  organizationsFeature.selectors
                    .getOrganizationEc(entity.id)
                    .asSignal(),
                )
                .filter(TypeChecker.isNotNullish.raw),
            )
            .pipe(
              rxjs.map(relatedEc =>
                relatedEc.plugins.currentListPlugin.feature.actions.load
                  .from(action)
                  .create(),
              ),
            ),
        ),
      ),
)
